import {defineMessages} from "@project/i18n";

export const contactFieldLabelIds = {
  description: "fields.contact.description",
  email: "fields.contact.email",
  name: "fields.contact.name",
  phoneNumber: "fields.contact.phoneNumber",
  phonePrefix: "fields.contact.phonePrefix",
} as const;

export const contactFieldMessages = defineMessages({
  description: {
    id: "fields.contact.description",
    defaultMessage: "Description",
    description: "Contact field label for description",
  },
  email: {
    id: "fields.contact.email",
    defaultMessage: "Email",
    description: "Contact field label for email",
  },
  name: {
    id: "fields.contact.name",
    defaultMessage: "Name",
    description: "Contact field label for name",
  },
  phoneNumber: {
    id: "fields.contact.phoneNumber",
    defaultMessage: "Phone number",
    description: "Contact field label for phone number",
  },
  phonePrefix: {
    id: "fields.contact.phonePrefix",
    defaultMessage: "Phone prefix",
    description: "Contact field label for phone prefix",
  },
});
